import { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { useNavigate, useLocation, Link as RouterLink } from "react-router-dom";
import { Formik, Form } from "formik";
import styled from "@emotion/styled";
import * as Yup from "yup";
// css
import './CreatePassword.css'
import logo from '../../../Assets/images/logo.png';
import { Icon } from "@iconify/react";
// custom imports
import showToast from "../../../Utils/Toast/ToastNotification";
import authService from "../../../Services/Login/LoginService";
import { HandleApiError } from "../../../Utils/CommonErrors/HandleApiError";

const RootStyle = styled("div")({
  background: "rgb(249, 250, 251)",
  height: "100vh",
  display: "grid",
  placeItems: "center",
});

const HeadingStyle = styled(Box)({
  textAlign: "center",
});

const ContentStyle = styled("div")({
  maxWidth: 480,
  padding: 25,
  margin: "auto",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  background: "#fff",
});

// Easing for animation
let easing = [0.6, -0.05, 0.01, 0.99];
const animate = {
  opacity: 1,
  y: 0,
  transition: {
    duration: 0.6,
    ease: easing,
    delay: 0.16,
  },
};

const CreatePassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = new URLSearchParams(location.search).get("token");

  const [email, setEmail] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [tokenValid, setTokenValid] = useState(false);

  const createPasswordSchema = Yup.object().shape({
    password: Yup.string()
      .min(8, "Password must be at least 8 characters long")
      .required("Password is required")
      .matches(/^$|^\S+.*/, "Only blank spaces are not valid."),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password is required"),
  });

  useEffect(() => {
    const checkTokenValidity = async () => {
      try {
        const response = await authService.verifyToken({ token });
        if (response?.data?.statusCode === 200) {
          setEmail(response?.data?.body?.data?.email);

          setTokenValid(true);
        } else {
          showToast("error", response?.body?.message);
          navigate("/forgot-password");
        }
      } catch (error) {
        showToast("error", "Token Expired");
        navigate("/forgot-password");
      }
    };

    if (token) {
      checkTokenValidity();
    } else {
      navigate("/forgot-password");
    }
  }, [token, navigate]);


  const onSubmit = async (values) => {
    const data = {
      newPassword: values.password,
      token: token,
    };
    try {
      const response = await authService.createPassword(data);

      if (response?.data?.statusCode === 200) {
        showToast("success", response?.data?.body?.message);
        navigate("/");
      } else {
        showToast("error", response?.data?.body?.message || "Something went wrong");
      }
    } catch (error) {
      await HandleApiError(error)
    }
  };

  return (
    <>
      <section className="login-main">
        <div className="login-block d-flex">
          <div className="logo-mobile">
            <img src={logo}></img>
          </div>
          <div className="banner-img-block">
          </div>
          <div className="login-info-block d-flex flex-column align-items-center">
            <div className="logo">
              <img src={logo}></img>
            </div>
            <div className="signup-box">
              <div className="inner-box">
                <div className="d-flex">
                  <h1 className="login_header">Create New Password</h1>
                </div>
                <Formik
                  enableReinitialize
                  initialValues={{
                    email: email,
                    password: "",
                    confirmPassword: "",
                  }}
                  validationSchema={createPasswordSchema}
                  onSubmit={onSubmit}
                >
                  {({ values, handleChange, handleBlur, errors, touched }) => (
                    <Form className="login-form">
                      <div class="mb-3 email-blk">
                        <label for="email" class="form-label">Email</label>
                        <input
                          type="email"
                          class="form-control"
                          id="email"
                          value={values.email}
                          readOnly
                        />
                      </div>


                      <div class="mb-3 position-relative">
                        <label for="password" class="form-label"> New Password</label>
                        <div class="input-group input-blk">
                          <input
                            type={showPassword ? "text" : "password"}
                            class="form-control"
                            id="password"
                            placeholder="Password"
                            onChange={handleChange}
                            value={values.password}
                            onBlur={handleBlur}
                          />

                          <div
                            className="eye-icon"
                            onClick={() => setShowPassword(!showPassword)}
                            style={{ cursor: "pointer" }}
                          >
                            {showPassword ? (
                              <Icon icon="mdi:eye" width="24" height="24" fill="#718096" />
                            ) : (
                              <Icon icon="mdi:eye-off" width="24" height="24" fill="#718096" />
                            )}
                          </div>
                        </div>
                        {touched.password && errors.password && (
                          <div className="error-text text-danger">{errors.password}</div>
                        )}
                      </div>
                      <div class="mb-3 position-relative">
                        <label for="password" class="form-label">Confirm Password</label>
                        <div class="input-group input-blk">
                          <input
                            type={showConfirmPassword ? "text" : "password"}
                            class="form-control"
                            id="confirmPassword"
                            name="confirmPassword"
                            placeholder="Password"
                            onChange={handleChange}
                            value={values.confirmPassword}
                            onBlur={handleBlur}
                          />
                          <div
                            className="eye-icon"
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            style={{ cursor: "pointer" }}
                          >
                            {showConfirmPassword ? (
                              <Icon icon="mdi:eye" width="24" height="24" fill="#718096" />
                            ) : (
                              <Icon icon="mdi:eye-off" width="24" height="24" fill="#718096" />
                            )}
                          </div>
                        </div>
                        {touched.confirmPassword && errors.confirmPassword && (
                          <div className="error-text text-danger">{errors.confirmPassword}</div>
                        )}
                      </div>
                      <button
                        type="submit"
                        class="green-btn green-signin w-100"
                      >
                        Update Password
                      </button>
                      <div className="go-back text-center">Back to Sign In? <a href="/">Go Back</a></div>
                    </Form>)}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </section >
    </>
  );
};

export default CreatePassword;




